import cn from 'classnames';

import { hasNonWhiteTheme } from 'src/utils/hasNonWhiteTheme';

import { ComponentProps } from 'src/types/component-props';
import { CoreRichTextData } from 'src/types/components';

import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import styles from './CoreRichText.module.scss';

export type CoreRichTextProps = ComponentProps & CoreRichTextData;

const CoreRichText = ({ fields }: CoreRichTextProps): JSX.Element => {
  const { eyebrow, heading, copy, theme, anchorTag } = fields || {};

  if (!copy) {
    return <></>;
  }

  const sectionClasses = cn('spacer', styles.mainWrapper, styles[`theme--${theme}`], {
    'spacer--with-vertical-padding': hasNonWhiteTheme(theme),
  });

  return (
    <section id={anchorTag} className={sectionClasses}>
      <div className={cn(styles.main, 'container', 'container--true-1440')}>
        {eyebrow && (
          <div className={cn(styles.eyebrow)}>
            <Text field={eyebrow} />
          </div>
        )}
        {heading && (
          <h2 className={cn(styles.heading)}>
            <Text field={heading} />
          </h2>
        )}
        <RichText className={styles.rteBox} field={copy} />
      </div>
    </section>
  );
};

export default CoreRichText;
